import { bangkokDayKey, daysBetween } from './journeyTime'

const FOLD_ABOVE_ROWS = 15
const OTHER_ORDER_NAMES = ['order_placed', 'quotation_requested', 'quotation_sent', 'purchase', 'deposit_paid']

const isMessage = (step) => step.kind === 'message'
const isVisit = (step) => step.kind === 'visit'
const isOtherOrder = (step) => step.kind === 'event' && OTHER_ORDER_NAMES.includes(step.name)

const stepsByDay = (steps) => {
  const groups = new Map()
  steps.forEach((step) => {
    const dayKey = bangkokDayKey(step.first_at)
    if (!dayKey) return
    if (!groups.has(dayKey)) groups.set(dayKey, { dayKey, firstAt: step.first_at, steps: [] })
    groups.get(dayKey).steps.push(step)
  })
  return groups
}

const groupByDay = (steps, startedAt) => {
  const groups = stepsByDay(steps)
  const orderDay = bangkokDayKey(startedAt)
  if (orderDay && !groups.has(orderDay)) groups.set(orderDay, { dayKey: orderDay, firstAt: startedAt, steps: [] })
  const days = [...groups.values()].sort((a, b) => a.dayKey.localeCompare(b.dayKey))
  return days.map((day, index) => ({
    ...day,
    daysBefore: orderDay ? daysBetween(day.dayKey, orderDay) : null,
    gapBefore: index === 0 ? 0 : Math.max(daysBetween(days[index - 1].dayKey, day.dayKey) - 1, 0)
  }))
}

const latestEarlierActiveDay = (days) => {
  const earlier = days.filter((day) => day.daysBefore > 0 && day.steps.some((step) => !isOtherOrder(step)))
  return earlier.length ? earlier[earlier.length - 1].dayKey : null
}

const foldDays = (days, { allOpen, openedDays }) => {
  const rows = days.reduce((count, day) => count + day.steps.length, 0) + 1
  const foldable = rows > FOLD_ABOVE_ROWS
  const latestEarlier = latestEarlierActiveDay(days)
  const isOpen = (day) =>
    !foldable || allOpen || day.daysBefore <= 0 || day.dayKey === latestEarlier || openedDays.includes(day.dayKey)
  return { foldable, days: days.map((day) => ({ ...day, open: isOpen(day) })) }
}

const foldedSteps = (days) =>
  days.filter((day) => !day.open).reduce((count, day) => count + day.steps.filter((step) => !isOtherOrder(step)).length, 0)

const dayTotals = (steps) => {
  const totals = []
  steps.filter((step) => !isOtherOrder(step)).forEach((step) => {
    const found = totals.find((total) => total.name === step.name && total.kind === step.kind)
    const count = isVisit(step) ? 1 : step.count || 1
    if (found) found.count += count
    else totals.push({ name: step.name, kind: step.kind, count })
  })
  return totals
}

export {
  FOLD_ABOVE_ROWS,
  isMessage,
  isVisit,
  isOtherOrder,
  groupByDay,
  foldDays,
  foldedSteps,
  dayTotals
}
